'use client';

import { createContext, useContext } from 'react';

export interface Attachment {
  id: string;
  type: 'image' | 'video';
  file?: File;
  url?: string;
  name: string;
  status: 'uploading' | 'ready' | 'error';
}

interface ComposerContextValue {
  pendingAttachments: Attachment[];
  onImageSelect: (files: FileList) => Promise<void>;
  onRemoveAttachment: (id: string) => void;
  onVideoUpload: () => void;
}

const ComposerContext = createContext<ComposerContextValue | null>(null);

export function ComposerContextProvider({
  children,
  value
}: {
  children: React.ReactNode;
  value: ComposerContextValue;
}) {
  return (
    <ComposerContext.Provider value={value}>
      {children}
    </ComposerContext.Provider>
  );
}

export function useComposerContext() {
  const context = useContext(ComposerContext);
  if (!context) {
    // Return safe defaults when used outside provider (e.g., in non-Momento contexts)
    return {
      pendingAttachments: [],
      onImageSelect: async () => {},
      onRemoveAttachment: () => {},
      onVideoUpload: () => {},
    };
  }
  return context;
}
